import React from 'react';
import SaleItem from '@components/sale-item';
/**
 * セールアイテム一覧の生成
 * @param saleItemList
 * @returns
 */
const createSaleItemElements = (saleItemList) => {
    return saleItemList.map((saleItem, index) => {
        return React.createElement(SaleItem, { saleItem: saleItem, key: `${saleItem.name}${index}` });
    });
};
const SaleItemGroup = ({ saleItemList }) => {
    return (React.createElement("div", { className: "sale-item-group" }, createSaleItemElements(saleItemList)));
};
export default SaleItemGroup;
